import {
    SHOW_SB_TRADE_ONBOARDING,
    SB_TRADE_ONBOARDING_PRIORITY,
} from '../sbRespNotificationConstants';
import { sbTradeOnboardingRule } from '../../../global/tradeOnboarding/tradeOnboardingRules';

export const sbRespNotificationTradeOnboardingConfig = {
    name: 'sbTradeOnboardingNotification',
    priority: SB_TRADE_ONBOARDING_PRIORITY,
    rule: sbTradeOnboardingRule,
    action: () => dispatch => {
        dispatch({
            type: SHOW_SB_TRADE_ONBOARDING,
        });
    },
};
